import { ConnexionPageState } from "../ConnexionPageState";
import { ConnexionPageInitial } from "./ConnexionPageInitial";

export class ConnexionPageSendMail extends ConnexionPageState{
    /**
     * 
     * Valide le message de confirmation de mail et :
     *  - retourne sur la page de connexion si l'utilisateur n'est pas authentifié
     *  - finalise la procédure de connexion si l'utilisateur est authentifié
     */
    public async SignIn(): Promise<void> {
        this.context.ShowMailSend = false;
        if(this.context.SignInResult){
            /** L'utilisateur est déjà authentifié. déconnexion et redirection page de connexion*/
            this.context.Vue.$router.push('SignOut')
        } else {
            /** L'utilisateur n'est pas authentifié. Redirection vers la page de connexion ?*/
            this.context.ShowLoginForm = true;
            this.context.State = new ConnexionPageInitial(this.context);
        }
    }

    //#region CAS INGORE
    /** VOID */
    public ResetPassword(): void { /** Impossible de revenir en arrière */ }

    /** VOID */
    public async SendMail(): Promise<void> { /** Aucun mail ne peut être envoyé durant cette étape */ }

    /** VOID */
    public async Abord(): Promise<void> { /** Non proposé à l'utilisateur */ }

    /** VOID */
    public About(): void { /** Non proposé à l'utilisateur */ }
    //#endregion CAS INGORE
}